import React, { useEffect, useState } from 'react'
import Menu from '../Menu/Menu'
import LoaderAdmin from '../LoaderAdmin'
import { useUsersContext } from '../../Context/UsersContext';
import { useAdminContext } from '../../Context/AdminContext';
import { useStorageContext } from '../../Context/StorageContext';
import UploadHandler from '../NewArticle/UploadHandler';
import GalleryImage from '../NewArticle/GalleryImage';
export default function Gallery() {
  const { loggedData } = useUsersContext();
  const { allImagesLinks } = useStorageContext();

  const itemsPerPage = 10;
  const [currentPage, setCurrentPage] = useState(1);
  const [getItemsForCurrentPage, setGetItemsForCurrentPage] = useState([]);
  const [addNew, setAddNew] = useState(false);
  const [newUpload, setNewUpload] = useState(false);
  const [search, setSearch] = useState("");
  const [phQuantity, setPhQuantity] = useState(1);
  const [url, setUrl] = useState(null);



  const {
    uploadedShop,
    uploadedZip,
    uploadingZip,
    bigImg,
    alreadyExists,
    handleUploadShopImage,
    handleChange,
  } = useAdminContext ();

  


  const addNewF = () => {
    setCurrentPage(1)
    setAddNew(!addNew);
  };

  useEffect(() => {
    const startIndex = (currentPage - 1) * itemsPerPage;
    const endIndex = startIndex + itemsPerPage;
    setGetItemsForCurrentPage(
      allImagesLinks
        .filter((e) => e.toUpperCase().includes(search.toUpperCase()))
        .slice(startIndex, endIndex)
    );
  }, [allImagesLinks, search, currentPage, newUpload]);

  // Función para ir a la página anterior
  const goToPreviousPage = () => {
    setCurrentPage((prevPage) => Math.max(prevPage - 1, 1));
    window.scrollTo(0, 0);
  };

  // Función para ir a la página siguiente
  const goToNextPage = () => {
    const maxPage = Math.ceil(allImagesLinks.length / itemsPerPage);
    setCurrentPage((prevPage) => Math.min(prevPage + 1, maxPage));
    window.scrollTo(0, 0);
  };

  
  const handleSelectShopImage = (a) => {
    setUrl(`${a}`);

    setTimeout(() => {
      setPhQuantity(phQuantity + 1);
    }, 200);
  };


  return (
    <div className="admin-section-cont">
   {loggedData ? (
        <>
          <Menu />
          <div className="w85 position-relative">
          <div className="admin-images-gallery-section">
      <div className="admin-images-gallery-row-column">
        <div
          className={`admin-images-gallery-choser ${
            addNew ? "choser-100" : newUpload ? "choser-none" : ""
          } `}
          onClick={ !addNew ? () => {
            addNewF()
          } : null}
        >
          {!addNew ? (
            <>
              <img
                width="50"
                height="50"
                src="https://img.icons8.com/ios/50/add--v1.png"
                alt="add--v1"
              />
              <p> Subir nueva foto</p>
            </>
          ) : (
            <>
             <button className="buttonstyle"  onClick={addNewF} ><img width="30" height="30" src="https://img.icons8.com/fluency-systems-filled/96/circled-left-2--v2.png" alt="circled-left-2--v2"/></button>

             <UploadHandler handleSelectShopImage={handleSelectShopImage} />

            </>
          )}
        </div>

        <div
          className={`admin-images-gallery-choser ${
            newUpload ? "choser-100" : addNew ? "choser-none" : ""
          } `}
          onClick={ !newUpload ? () => {
            setNewUpload(!newUpload);
          } : null }
        >

{!newUpload ? (
            <>
          <img
            width="50"
            height="50"
            src="https://img.icons8.com/wired/64/gallery.png"
            alt="gallery"
          />
          <p>GALERÍA</p>
            </>
          ) : (
            <>
             <button className="buttonstyle"  onClick={() => {
            setNewUpload(!newUpload);
          }} ><img width="30" height="30" src="https://img.icons8.com/fluency-systems-filled/96/circled-left-2--v2.png" alt="circled-left-2--v2"/></button>

             <div className="rowOfImagesEdit">
            {getItemsForCurrentPage.map((e) => (
              <GalleryImage
                key={e}
                url={e}
                handleSelectShopImage={handleSelectShopImage}
                chosingCover={null}
                choseCoverF={null}
                insertImageMode={null}
                insertImageF={null}
                galleryForLink={null}
                handleInsert={null}
                AdmGal={true}
              />
            ))}
          </div>
          <div className="searcherRow">
            <img
              className="lupaImg"
              width="25"
              height="25"
              src="https://img.icons8.com/ios/100/search--v1.png"
              alt="search--v1"
            />
            <input
              onChange={(e) => setSearch(e.target.value)}
              placeholder="Buscá por nombre de archivo"
              className="input w20rem"
            ></input>
          </div>
          <div className="changerPageButtonCont">
            <button
              className="buttonbyn"
              onClick={goToPreviousPage}
              disabled={currentPage === 1}
            >
              Anterior
            </button>

            <button className="buttonbyn" onClick={goToNextPage}>
              Siguiente
            </button>
          </div>

            </>
          )}


        </div>
      </div>

     


    </div>
          </div>
        </>
      ) : (
        <LoaderAdmin loggedData={loggedData} />
      )}
  </div>
  )
}
